export function diff<T1, T2>(a1:T1[], a2:T2[], fn:(i1:T1, i2:T2) => boolean) {
	return a1.filter(i1 => a2.findIndex(i2 => fn(i1, i2)) < 0);
}